import lodash from 'lodash';
import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    Select, Spin, Button, Input, Form, Row, Col,
} from 'antd';
import Moment from 'react-moment';
import { get } from '../../../../../shared/helpers';
import { getLeadsCapBrandsRequest } from '../../redux/actions/cap_actions/get_cap_brands.actions';
import { getLeadsCapModelsRequest } from '../../redux/actions/cap_actions/get_cap_models.actions';
import { getLeadsCapVersionsRequest } from '../../redux/actions/cap_actions/get_cap_versions.actions';
import { getLeadsCapDerivativesRequest } from '../../redux/actions/cap_actions/get_cap_derivatives.actions';
import { getLeadsCapRegistrationRequest } from '../../redux/actions/cap_actions/get_cap_registration.actions';
import { getLeadsCapValuationRequest } from '../../redux/actions/cap_actions/get_cap_valuation.actions';

const mapStateToProps = (state) => {
    const {
        capBrands, capDerivatives, capModels, capVersions, capRegistration,
    } = state.Leads.Lead_profile.Lead_cap_valuation;
    const { bike_details } = state.Leads.Lead_profile.Ref_bike_lead;
    return {
        capBrands, capModels, capVersions, capDerivatives, capRegistration, bike_details,
    };
}; const Options = Select.Option; const FormItem = Form.Item; let capModels = null; let capVersions = null; let capDerivatives = null; let
    capRegistration = null;

export default connect(mapStateToProps, null)(class CapValuationModal extends PureComponent {
    state = {
        fetching: false,
        modelDisabled: true,
        versionDisabled: true,
        yearDisabled: true,
        regDisabled: true,
        capBrandId: '',
        capModelId: '',
        capVersionId: '',
        capDerivativeId: 0,
        derivativeIntroduced: '',
        derivativeDiscontinued: '',
        capRegistrationId: '',
        capRegistrationFullYear: '',
        capRegistrationYear: '',
        capRegistrationYearCode: '',
        capMileage: this.props.bike_details ? this.props.bike_details.mileage : '',
    };

    getCapBrands = () => {
        this.props.dispatch(getLeadsCapBrandsRequest());
        this.setState({ fetching: true });
    };

    handleCapBrandChange = (value, key) => {
        if (value) {
            this.setState({ capBrandId: key.key, modelDisabled: false });
        } else {
            capModels.rcSelect.state.value = [];
            capVersions.rcSelect.state.value = [];
            capDerivatives.rcSelect.state.value = [];
            capRegistration.rcSelect.state.value = [];
            this.setState({
                modelDisabled: true, versionDisabled: true, yearDisabled: true, regDisabled: true,
            });
        }
    };

    getCapModels = () => {
        this.props.dispatch(getLeadsCapModelsRequest(+this.state.capBrandId));
        this.setState({ fetching: true });
    };

    handleCapModelChange = (value, key) => {
        if (value) {
            this.setState({ capModelId: key.key, versionDisabled: false });
        } else {
            capVersions.rcSelect.state.value = [];
            capDerivatives.rcSelect.state.value = [];
            capRegistration.rcSelect.state.value = [];
            this.setState({ versionDisabled: true, yearDisabled: true, regDisabled: true });
        }
    };

    getCapVersions = () => {
        this.props.dispatch(getLeadsCapVersionsRequest(+this.state.capModelId));
        this.setState({ fetching: true });
    };

    handleCapVersionChange = (value, key) => {
        if (value) {
            this.setState({ capVersionId: key.key, yearDisabled: false });
        } else {
            capDerivatives.rcSelect.state.value = [];
            capRegistration.rcSelect.state.value = [];
            this.setState({ yearDisabled: true, regDisabled: true });
        }
    };

    getCapDerivatives = () => {
        this.props.dispatch(getLeadsCapDerivativesRequest(+this.state.capVersionId));
        this.setState({ fetching: true });
    };

    handleCapDerivativesChange = (value, key) => {
        if (value) {
            this.setState({
                capDerivativeId: parseInt(key.key, 10),
                derivativeIntroduced: get(key, 'props.data.derivative_introduced'),
                derivativeDiscontinued: get(key, 'props.data.derivative_discontinued'),
                regDisabled: false,
            });
        } else {
            capRegistration.rcSelect.state.value = [];
            this.setState({ regDisabled: true });
        }
    };

    getCapRegistration = () => {
        const derivativeDiscontinued = this.state.derivativeDiscontinued ? +this.state.derivativeDiscontinued.slice(0, 4) : this.state.derivativeDiscontinued;

        this.props.dispatch(getLeadsCapRegistrationRequest(+this.state.derivativeIntroduced.slice(0, 4), derivativeDiscontinued));
        this.setState({ fetching: true });
    };

    handleCapRegistrationChange = (value, key) => {
        this.setState({
            capRegistrationId: key.key,
            capRegistrationFullYear: value,
            capRegistrationYear: get(key, 'props.data.capRegistrationYear'),
            capRegistrationYearCode: get(key, 'props.data.capRegistrationYearCode'),
        });
    };

    handleCapMileageChange = event => this.setState({ capMileage: event.target.value });

    checkValuation = () => {
        const {
            capDerivativeId, capRegistrationFullYear, capRegistrationYear, capRegistrationYearCode, capMileage,
        } = this.state;
        const { closeModal, bike_details, dispatch } = this.props;
        dispatch(getLeadsCapValuationRequest(capDerivativeId, capRegistrationFullYear, capRegistrationYear, capRegistrationYearCode, +capMileage, bike_details._id));
        closeModal();
    };

    render() {
        const { fetching } = this.state;
        const { bike_details } = this.props;

        return (
            <Fragment>
                <h4 className="bold-text  modal__title" style={{ marginBottom: '4%' }}>Manual CAP Valuation</h4>
                <div className="bikeSummary">
                    <p>
                        <label>Bike Name:</label>
                        {' '}
                        {lodash.get(bike_details, 'experian_name') || '-'}
                    </p>
                    <p>
                        <label>Make:</label>
                        {' '}
                        {lodash.get(bike_details, 'ref_bike_brand.name') || '-'}
                    </p>
                    <p>
                        <label>Model:</label>
                        {' '}
                        {this.props.bike_details.ref_bike_model ? this.props.bike_details.ref_bike_model.name : this.props.bike_details.unmaped_data ? this.props.bike_details.unmaped_data.bike_model : '-'}
                    </p>
                    <p>
                        <label>Variant:</label>
                        {' '}
                        {this.props.bike_details.ref_bike_model ? this.props.bike_details.ref_bike_model.model_variation : this.props.bike_details.unmaped_data ? this.props.bike_details.unmaped_data.bike_model_variant : '-'}
                    </p>
                    <p>
                        <label>Mileage:</label>
                        {' '}
                        {this.props.bike_details.mileage}
                    </p>
                    <p>
                        <label>Year of Manufacture:</label>
                        {' '}
                        {this.props.bike_details.ref_bike_variant ? this.props.bike_details.ref_bike_variant.year : this.props.bike_details.unmaped_data ? this.props.bike_details.unmaped_data.bike_year : ''}
                    </p>
                </div>
                <Form>
                    <Row gutter={50}>
                        <Col md={12}>
                            <FormItem label="Brand">
                                <Select
                                    allowClear
                                    showSearch
                                    placeholder="Select Make"
                                    filterOption
                                    notFoundContent={fetching ? <Spin size="small" /> : null}
                                    onFocus={this.getCapBrands}
                                    onChange={this.handleCapBrandChange}
                                >
                                    {this.props.capBrands && this.props.capBrands.map(brand => <Options value={brand.man_name} key={brand.man_code}>{brand.man_name}</Options>)}
                                </Select>
                            </FormItem>
                            <FormItem label="Model">
                                <Select
                                    allowClear
                                    showSearch
                                    placeholder="Select Model"
                                    ref={element => capModels = element}
                                    disabled={this.state.modelDisabled}
                                    notFoundContent={fetching ? <Spin size="small" /> : null}
                                    filterOption
                                    onFocus={this.getCapModels}
                                    onChange={this.handleCapModelChange}
                                >
                                    {this.props.capModels && this.props.capModels.map(brand => <Options value={brand.range_name} key={brand.range_code}>{brand.range_name}</Options>)}
                                </Select>
                            </FormItem>
                            <FormItem label="Version">
                                <Select
                                    allowClear
                                    showSearch
                                    placeholder="Select Version"
                                    ref={element => capVersions = element}
                                    disabled={this.state.versionDisabled}
                                    onFocus={this.getCapVersions}
                                    notFoundContent={fetching ? <Spin size="small" /> : null}
                                    filterOption
                                    onChange={this.handleCapVersionChange}
                                >
                                    {this.props.capVersions && this.props.capVersions.map(brand => <Options value={brand.variant_name} key={brand.variant_code}>{brand.variant_name}</Options>)}
                                </Select>
                            </FormItem>
                        </Col>
                        <Col md={12}>
                            <FormItem label="Year Manufactured">
                                <Select
                                    allowClear
                                    showSearch
                                    placeholder="Select Year Manufactured"
                                    ref={element => capDerivatives = element}
                                    notFoundContent={fetching ? <Spin size="small" /> : null}
                                    filterOption
                                    disabled={this.state.yearDisabled}
                                    onFocus={this.getCapDerivatives}
                                    onChange={this.handleCapDerivativesChange}
                                >
                                    {this.props.capDerivatives && this.props.capDerivatives.map(brand => {
                                        const introducedYear = brand.derivative_introduced;
                                        const isDisabled = introducedYear && new Date(introducedYear).getFullYear() === new Date().getFullYear();

                                        return (
                                            <Options
                                                value={brand.derivative_name}
                                                key={brand.derivative_id}
                                                data={{ derivative_introduced: brand.derivative_introduced, derivative_discontinued: brand.derivative_discontinued }}
                                                disabled={isDisabled}
                                            >
                                                {brand.derivative_name}
                                                {' '}
                                                - (
                                                <Moment format="YYYY">{brand.derivative_introduced}</Moment>
                                                {' '}
                                                -
                                                {' '}
                                                <Moment format="YYYY">{brand.derivative_discontinued}</Moment>
                                                )
                                                {' '}
                                                {isDisabled && <span>(Not captured)</span>}
                                            </Options>
                                        );
                                    })}
                                </Select>
                            </FormItem>
                            <FormItem label="Registration Year">
                                <Select
                                    allowClear
                                    showSearch
                                    placeholder="Select Registration Year"
                                    ref={element => capRegistration = element}
                                    notFoundContent={fetching ? <Spin size="small" /> : null}
                                    filterOption
                                    disabled={this.state.regDisabled}
                                    onFocus={this.getCapRegistration}
                                    onChange={this.handleCapRegistrationChange}
                                >
                                    {this.props.capRegistration
                                    && this.props.capRegistration.map(brand => (
                                        <Options
                                            value={brand.full_year}
                                            key={brand.year}
                                            data={{
                                                capRegistrationFullYear: brand.full_year,
                                                capRegistrationYear: brand.year,
                                                capRegistrationYearCode: brand.code,
                                            }}
                                        >
                                            {brand.code.replace(' ', ' / ')}
                                        </Options>
                                    ))}
                                </Select>
                            </FormItem>
                            <FormItem label="Mileage">
                                <Input
                                    defaultValue={this.props.bike_details.mileage}
                                    onChange={this.handleCapMileageChange}
                                />
                            </FormItem>
                        </Col>
                    </Row>


                    <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '20px 0' }}>
                        <Button onClick={this.props.closeModal}>Cancel</Button>
                        <Button type="primary" style={{ marginLeft: 10 }} onClick={this.checkValuation}>Check</Button>
                    </div>
                </Form>
            </Fragment>
        );
    }
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Modals/CapValuationModal.js